"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SsoStateSchema = void 0;
const zod_1 = __importDefault(require("zod"));
exports.SsoStateSchema = zod_1.default.object({
    existingQueryParams: zod_1.default.string().optional(),
    successRedirectUrl: zod_1.default.string(),
    errorRedirectUrl: zod_1.default.string(),
});
